import { VStack, Text, BoxProps, Box } from "@chakra-ui/react";

interface CardProps extends BoxProps {
  title: string;
  value: string;
}

const KYDCard = ({ title, value, ...props }: CardProps) => {
  return (
    <Box
      border="1px solid #DDDDDD"
      borderRadius="10px"
      p={4}
      background="linear-gradient(180deg, rgba(231, 233, 239, 0.01) 0%, #FFF 100%), #FFF"
      boxShadow="0px 1px 2px 0px rgba(255, 255, 255, 0.75) inset, 0px 4px 12px -5px rgba(0, 0, 0, 0.04)"
      {...props}
    >
      <Text
        color="#494949"
        fontSize="13px"
        fontWeight="500"
        letterSpacing="-0.39px"
      >
        {title}
      </Text>
      <Text
        color="#222222"
        fontSize="20px"
        fontWeight="400"
        letterSpacing="-0.6px"
      >
        {value}
      </Text>
    </Box>
  );
};

export default KYDCard;
